

import React, { useEffect, useState } from 'react';
import ExcelApp from './ExcelTable';
import ExcelTable from './ExcelTable';
import { Services } from '../../network/Services';
import AoUrl from '../../network/url';
import ExcelExtracter from '../ExcelExtracter';
import EntitiesTable from './EntitiesTable';
import './ExcelSheet.css';
import AttorneyReport from './AttorneyReport';
import ARDeptReport from './ARDeptReport';
import { demo, federal_way_plazaId, subtenantId4AttorneyReport, getTargetDate } from '../../control/Constant';
import config from '../../config.json';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatDate, formatToUSD } from "../../network/helper";


const ExcleDashbord = ({setuseLoader,setShowExcle,subtenantIdExcel}) => {
  const months = [
  { id: 1, name: "Jan" },
  { id: 2, name: "Feb" },
  { id: 3, name: "Mar" },
  { id: 4, name: "Apr" },
  { id: 5, name: "May" },
  { id: 6, name: "Jun" },
  { id: 7, name: "Jul" },
  { id: 8, name: "Aug" },
  { id: 9, name: "Sep" },
  { id: 10, name: "Oct" },
  { id: 11, name: "Nov" },
  { id: 12, name: "Dec" },
];

function getCurrentMonth() {
  const now = new Date();
  const month = now.getMonth();
  return month + 1;
}

const [selectedMonth,setSelectedMonth] = useState(getCurrentMonth());
const [selectedYear,setSelectedYear] = useState(2026);
const [searchedMonth,setSearchedMonth] = useState(1);
const [searchedYear,setSearchedYear] = useState(2026);
const [yearlyData,setYearlyData] = useState([])
const [monthlyData,setMonthlyData] = useState([])
const [yearlyDatalpl,setYearlyDatalpl] = useState([])
const [yearlyDataAo,setYearlyDataAo] = useState([])
const [yearlyDataNd,setYearlyDataNd] = useState([])
const [yearlyDataFw,setYearlyDataFw] = useState([])
const [yearlyDataAll,setYearlyDatalplAll] = useState([])
const [monthlyDatalpl,setMonthlydatalpl] = useState([])
const [monthlyDataAll,setMonthlydataAll] = useState([])
const [showAttorneyReport,setShowAttorneyReport] = useState(false)
const [showARDeptReport,setShowARDeptReport] = useState(false)
const [activeButton, setActiveButton] = useState('dashboard')
const [applyClicked, setApplyClicked] = useState(false)
const [downloadClicked, setDownloadClicked] = useState(false)
const [arDeptDashboardData, setArDeptDashboardData] = useState({
  sheetData: {
    mtdInitialsHeld: { total: 0, legalLifePlanning: 0, crisis: 0, probate: 0, seminar: 0, ama: 0, other: 0, refund: 0 },
    mtdRetained: { total: 0, legalLifePlanning: 0, crisis: 0, probate: 0, seminar: 0, ama: 0, other: 0, refund: 0 },
    closedPercentage: { total: "", legalLifePlanning: "", crisis: "", probate: "", seminar: "", ama: "", other: "", refund: "" },
    mtdRevenueRetained: { total: 0, legalLifePlanning: 0, crisis: 0, probate: 0, seminar: 0, ama: 0, other: 0, refund: 0 },
    mtdRevenueCollectedFromInitials: { total: 0, legalLifePlanning: 0, crisis: 0, probate: 0, seminar: 0, ama: 0, other: 0, refund: 0 },
    mtdRevenueCollectedNotFromInitials: { total: 0, legalLifePlanning: 0, crisis: 0, probate: 0, seminar: 0, ama: 0, other: 0, refund: 0 },
    totalCollected: { total: 0, legalLifePlanning: 0, crisis: 0, probate: 0, seminar: 0, ama: 0, other: 0, refund: 0 }
  },
  revenueCollected: {
    LegalLifePlanning: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Crisis: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Probate: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Seminar: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Ama: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Other: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Refunds: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Total: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" }
  }
});
const [revenueData,setRevenueData] = useState([])
const [attorneyMonthlyReport,setAttorneyMonthlyReport] = useState([])
const [monthlyDataAo,setMonthlydataAo] = useState([])
const [monthlyDataFw,setMonthlydataFw] = useState([])
const [lplexcelCard,setLplexcelcard] = useState({})
const [aoexcelCard,setAoexcelcard] = useState({})
const [fwexcelCard,setFwexcelcard] = useState({})
const [allexcelCard,setAllexcelcard] = useState({})
const [dashboardData, setDashboardData] = useState({
  sheetData: {
    mtdInitialsHeld: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: "", seminar: "", refunds: "", other: 0 },
    mtdInitialsRetained: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: "", seminar: "", refunds: "", other: 0 },
    closedPercentage: { total: "", rajiv: "", aaron: "", tim: "", ama: "", seminar: "", refunds: "", other: "" },
    mtdRevenueRetained: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: "", seminar: "", refunds: "", other: 0 },
    mtdRevenueCollected: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: "", seminar: "", refunds: "", other: 0 },
    mtdRevenueCollectedFromInitials: { total: 0, rajiv: "", aaron: "", tim: "", ama: "", seminar: "", refunds: "", other: "" },
    mtdRevenueCollectedNotFromInitials: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: 0, seminar: "", refunds: 0, other: "" },
    mtdTotalCollected: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: 0, seminar: 0, refunds: "", other: 0 },
    mtdGoal: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: 0, seminar: 0, refunds: "", other: 0 },
    mtdVariance: { total: 0, rajiv: 0, aaron: 0, tim: 0, ama: "", seminar: "", refunds: "", other: 0 },
    mtdVariancePercentage: { total: "", rajiv: "", aaron: "", tim: "", ama: "", seminar: "", refunds: "", other: "" }
  },
  revenueCollected: {
    Rajiv: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Aaron: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Tim: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Ama: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Seminar: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Other: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Refunds: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" },
    Total: { daily: "", yesterday: "", weekly: "", wtd: "", monthly: "", mtd: "", yearly: "", ytd: "" }
  }
});
const lplSubtenantId = 742;



const getLast10Years = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 15 }, (_, i) => {
    const year = currentYear - i;
    return { id: year, label: year };
  });
};



  const dailyRows = [
    { day: 1, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 2, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 3, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 4, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 5, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 6, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 7, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 8, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 9, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 10, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 11, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 12, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '0' },
    { day: 13, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 14, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 15, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 16, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 17, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 18, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 19, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 20, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 21, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 22, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 23, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 24, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 25, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 26, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 27, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 28, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 29, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 30, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
    { day: 31, lifePointLaw: '', ao: '', nagaichHoldings: '', fwpp: '', combined: '' },
  ];

  useEffect(()=>{
    getExcelData()
  },[])


  const getExcelDataApi =  async (isMonthly) => {

    let {startDate,endDate} = getStartAndEndDateOfYear(selectedYear)
    let {startDatem,endDatem} = getFirstAndLastDayOfMonthUTC(selectedYear,selectedMonth)

    let jsonObj = {
      "subtenantId": [
        lplSubtenantId,3,federal_way_plazaId
      ],
      "startDate": isMonthly == true ? startDatem :startDate,
      "endDate": isMonthly == true ? endDatem : endDate,
      "isMonthly": isMonthly == true ? true : false
    }
    setuseLoader(true)
    const getExceldataparam = await Services.postApiCallNew('POST',AoUrl.getExceldataurl,jsonObj);
    
    if(getExceldataparam != 'err'){
      if(getExceldataparam?.resPonse?.statusText == 'Not Found'){
        setuseLoader(false)
        resetState()
        return;
      }
      if(isMonthly == true) {
        setMonthlyData(getExceldataparam?.resPonse?.data?.data || [])
        if(getExceldataparam?.resPonse?.data?.data?.length > 0){
        let monthsObj = {months:[{days:[...adddummyDays()],month: months[selectedMonth-1]?.name,total:0}],year: selectedYear,yearTotal:0}
        setMonthlydatalpl(getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == lplSubtenantId)[0]?.years[0])
        setMonthlydataAo(getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == 3)[0]?.years[0] == undefined ? monthsObj : getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == 3)[0]?.years[0] )
        setMonthlydataFw(getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == federal_way_plazaId)[0]?.years[0]  == undefined ? monthsObj : getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == federal_way_plazaId)[0]?.years[0])
        let calculatedData = combineAllSubtenantsByDay(getExceldataparam?.resPonse?.data?.data)?.years[0]
        setMonthlydataAll(calculatedData)
        }
      }else{
        setuseLoader(false)
      setYearlyData(getExceldataparam?.resPonse?.data?.data || [])
      if(getExceldataparam?.resPonse?.data?.data?.length > 0){
        setYearlyDatalpl(getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == lplSubtenantId)[0])
        setYearlyDataAo(getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == 3)[0])
        setYearlyDataFw(getExceldataparam?.resPonse?.data?.data?.filter((e)=> e.subtenantId == federal_way_plazaId)[0])
        let calculatedData = mergeSubtenantMonths(getExceldataparam?.resPonse?.data?.data || [])
        setYearlyDatalplAll(calculatedData)
      }
      }
    }else{
      setuseLoader(false)
      resetState()
    }
  }

function mergeSubtenantMonths(data) {
  // Create a map to accumulate totals by year & month
  const merged = {};

  data?.forEach(subtenant => {
    subtenant.years.forEach(yearObj => {
      const { year, months } = yearObj;

      if (!merged[year]) {
        merged[year] = {}; // store months here
      }

      months.forEach(m => {
        if (!merged[year][m.month]) {
          merged[year][m.month] = 0;
        }
        merged[year][m.month] += m.total;
      });
    });
  });

  // Convert merged object into the required structure
  const years = Object.entries(merged).map(([year, months]) => {
    let yearTotal = 0;

    const monthsArr = Object.entries(months).map(([month, total]) => {
      yearTotal += total;
      return { month, total, days: [] };
    });

    return {
      year: parseInt(year),
      yearTotal,
      months: monthsArr
    };
  });

  // Return new subtenant with id 100
  return {
    subtenantId: 100,
    subtenantName: "Merged Subtenant",
    months: [],
    years
  };
}

function combineAllSubtenantsByDay(subtenants) {
  const result = {
    subtenantId: 10,
    subtenantName: null,
    months: [],
    years: []
  };

  const structure = {}; // { [year]: { [month]: { [day]: total } } }

  subtenants.forEach(sub => {
    sub.years?.forEach(year => {
      const y = year.year;
      if (!structure[y]) structure[y] = {};

      year.months?.forEach(month => {
        const m = month.month;
        if (!structure[y][m]) structure[y][m] = {};

        month.days?.forEach(day => {
          const d = day.day;
          if (!structure[y][m][d]) structure[y][m][d] = 0;

          structure[y][m][d] += day.total;
        });
      });
    });
  });

  // Build final output
  for (const [year, months] of Object.entries(structure)) {
    const yearEntry = {
      year: parseInt(year),
      yearTotal: 0,
      months: []
    };

    for (const [month, days] of Object.entries(months)) {
      const monthEntry = {
        month: month,
        total: 0,
        days: []
      };

      const sortedDays = Object.keys(days).sort((a, b) => a - b);

      sortedDays.forEach(day => {
        const total = parseFloat(days[day].toFixed(2));
        monthEntry.total += total;
        monthEntry.days.push({
          day: parseInt(day),
          total
        });
      });

      monthEntry.total = parseFloat(monthEntry.total.toFixed(2));
      yearEntry.yearTotal += monthEntry.total;
      yearEntry.months.push(monthEntry);
    }

    yearEntry.yearTotal = parseFloat(yearEntry.yearTotal.toFixed(2));
    result.years.push(yearEntry);
  }

  return result;
}

async function fetchAttorneyDataNewAPi(){
  // Format a date as YYYY-MM-DD
const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// 1️⃣ First date of the selected year
const yearFirstDate = formatDate(new Date(selectedYear, 0, 1));

// 2️⃣ Last date of the selected month
const currentMonthLastDate = formatDate(
  new Date(selectedYear, selectedMonth , 0)
);

const yesterDaysDate = getTargetDate(selectedMonth, selectedYear, 'YYYY-MM-DD');

  setuseLoader(true)
  let getAttorneyReportResp = await Services.getAttorneyReportAsync(yearFirstDate,currentMonthLastDate,yesterDaysDate);
  setuseLoader(false)
  getAttorneyReportResp=getAttorneyReportResp?.data?.[0]

  //-----Closed Percentage---
  const closedPercentagetotal=((getAttorneyReportResp?.mtdrnInitialsRetained || 0)+(getAttorneyReportResp?.mtdadpInitialsRetained || 0)+(getAttorneyReportResp?.mtdtksInitialsRetained || 0)+(getAttorneyReportResp?.mtdOtherInitialsRetained || 0) /(getAttorneyReportResp?.mtdrnInitialsHeld || 0)+(getAttorneyReportResp?.mtdadpInitialsHeld || 0)+(getAttorneyReportResp?.mtdtksInitialsHeld || 0)+(getAttorneyReportResp?.mtdOtherInitialsHeld || 0))
  const closedPercentagerajiv=((getAttorneyReportResp?.mtdrnInitialsRetained || 0)/(getAttorneyReportResp?.mtdrnInitialsHeld || 0))
  const closedPercentageaaron=((getAttorneyReportResp?.mtdadpInitialsRetained || 0)/(getAttorneyReportResp?.mtdadpInitialsHeld || 0))
  const closedPercentagetim=((getAttorneyReportResp?.mtdtksInitialsRetained || 0)/(getAttorneyReportResp?.mtdtksInitialsHeld || 0))
  const closedPercentageother=((getAttorneyReportResp?.mtdOtherInitialsRetained || 0)/(getAttorneyReportResp?.mtdOtherInitialsHeld || 0))

  //-- MTD Average Collection Per Retained Client
  const mtdTotalAvgColClient = ((getAttorneyReportResp?.mtdrnRevenueRetained || 0) + (getAttorneyReportResp?.mtdadpRevenueRetained || 0) + (getAttorneyReportResp?.mtdtksRevenueRetained || 0) + (getAttorneyReportResp?.mtdotherRevenueRetained || 0)) / ((getAttorneyReportResp?.mtdrnInitialsRetained || 0) + (getAttorneyReportResp?.mtdadpInitialsRetained || 0) + (getAttorneyReportResp?.mtdtksInitialsRetained || 0) + (getAttorneyReportResp?.mtdOtherInitialsRetained || 0));
  const mtdTotalRajeevAvgClient = (getAttorneyReportResp?.mtdrnRevenueRetained || 0) / (getAttorneyReportResp?.mtdrnInitialsRetained || 0);
  const mtdTotalAaronAvgClient = (getAttorneyReportResp?.mtdadpRevenueRetained || 0) / (getAttorneyReportResp?.mtdadpInitialsRetained || 0);
  const mtdTotalTimAvgClient = (getAttorneyReportResp?.mtdtksRevenueRetained || 0) / (getAttorneyReportResp?.mtdtksInitialsRetained || 0);
  const mtdTotalOtherAvgClient = (getAttorneyReportResp?.mtdotherRevenueRetained || 0) / (getAttorneyReportResp?.mtdOtherInitialsRetained || 0);


  //--MTD TOTAL COLLECTED---
  const mtdTotalretRajeev=(getAttorneyReportResp?.mtdrnRevenueCollectedFromInitials || 0) +(getAttorneyReportResp?.mtdrnRevenueCollectedFromNotInitials || 0)
  const mtdTotalretAaron=(getAttorneyReportResp?.mtdadpRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdadpRevenueCollectedFromNotInitials || 0)
  const mtdTotalretTim=(getAttorneyReportResp?.mtdtksRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdtksRevenueCollectedFromNotInitials || 0)
  const mtdTotalretAma=(getAttorneyReportResp?.amamtdRevenueFromInitial || 0) + (getAttorneyReportResp?.amamtdRevenueNotFromInitial || 0)
  const mtdTotalretSeminar=(getAttorneyReportResp?.sirmtdRevenueFromInitial || 0)
  const mtdTotalretRefund=(getAttorneyReportResp?.totalMonthlyRefund)
  const mtdTotalretOthers=(getAttorneyReportResp?.mtdOtherRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdOtherRevenueCollectedFromNotInitials || 0)

  const mtdTotalret = mtdTotalretRajeev + mtdTotalretAaron + mtdTotalretTim + mtdTotalretAma + mtdTotalretSeminar + mtdTotalretOthers + (mtdTotalretRefund || 0)

  
  //--MTD Goal Variables---
  const mtdGoalRajiv = 200000;
  const mtdGoalAaron = 100000;
  const mtdGoalTim = 50000;
  const mtdGoalAma = 15000;
  const mtdGoalSeminar = 10000;
  const mtdGoalOther = 50000;
  const mtdGoalTotal = mtdGoalRajiv + mtdGoalAaron + mtdGoalTim + mtdGoalAma + mtdGoalSeminar + mtdGoalOther;

  // Format amount with commas and brackets for negative values
  const formatAmountWithBrackets = (amount) => {
    if (amount <= 0) {
      return `$(${Math.abs(amount).toLocaleString()})`;
    }
    return `$${amount.toLocaleString()}`;
  };

  // Format amount with commas (for positive values)
  const formatAmount = (amount) => {
    return `$${amount.toLocaleString()}`;
  };


  //--MTD Variance Calculations ---
  const mtdVarianceTotal = (mtdTotalret - mtdGoalTotal || 0);
  const mtdVarianceRajiv = (mtdTotalretRajeev - mtdGoalRajiv || 0);
  const mtdVarianceAaron = (mtdTotalretAaron - mtdGoalAaron || 0);
  const mtdVarianceTim = (mtdTotalretTim - mtdGoalTim || 0);
  const mtdVarianceAma = (mtdTotalretAma - mtdGoalAma || 0);
  const mtdVarianceSeminar = (mtdTotalretSeminar - mtdGoalSeminar || 0);
  const mtdVarianceOther = (mtdTotalretOthers - mtdGoalOther || 0);

  //--MTD Variance Percentage Calculations ---
  const mtdVariancePercentageTotal = mtdGoalTotal !== 0 ? (mtdTotalret / mtdGoalTotal * 100) : 0;
  const mtdVariancePercentageRajiv = mtdGoalRajiv !== 0 ? (mtdTotalretRajeev / mtdGoalRajiv * 100) : 0;
  const mtdVariancePercentageAaron = mtdGoalAaron !== 0 ? (mtdTotalretAaron / mtdGoalAaron * 100) : 0;
  const mtdVariancePercentageTim = mtdGoalTim !== 0 ? (mtdTotalretTim / mtdGoalTim * 100) : 0;
  // const mtdVariancePercentageAma = mtdGoalAma !== 0 ? (mtdTotalCollectedAmountAma / mtdGoalAma * 100) : 0;
  // const mtdVariancePercentageSeminar = mtdGoalSeminar !== 0 ? (mtdTotalCollectedAmountSeminar / mtdGoalSeminar * 100) : 0;
  const mtdVariancePercentageOther = mtdGoalOther !== 0 ? (mtdTotalretOthers / mtdGoalOther * 100) : 0;

  // const mtdRevenueCollectedFromInitialstotal="$"+
  //      const mtdRevenueCollectedFromInitialsrajiv="$"+
  //      const mtdRevenueCollectedFromInitialsaaron="$"+
  //      const mtdRevenueCollectedFromInitialstim="$"+
  //      const mtdRevenueCollectedFromInitialsama="$"+
  //      const mtdRevenueCollectedFromInitialsseminar="$"+
  //      const mtdRevenueCollectedFromInitialsother="$"+

  // revenues collected calculations ------
  // revenues collected calculations for Rajiv ----
  const rajivRevenueCollectedDaily = 7500;
  const rajivRevenueCollectedWeekly = 37500;
  const rajivRevenueCollectedMonthly = 150000;
  const rajivRevenueCollectedYearly = 1800000;

  // revenues collected calculations for Aaron ----
  const aaronRevenueCollectedWeekly = 25000;
  const aaronRevenueCollectedMonthly = 100000;
  const aaronRevenueCollectedDaily = aaronRevenueCollectedWeekly / 5; // weekly / 5 working days
  const aaronRevenueCollectedYearly = aaronRevenueCollectedMonthly * 12; // monthly * 12

  // revenues collected calculations for Tim ----
  const timRevenueCollectedMonthly = 50000; // base value
  const timRevenueCollectedWeekly = timRevenueCollectedMonthly / 4; // monthly / 4
  const timRevenueCollectedDaily = timRevenueCollectedWeekly / 5; // weekly / 5 working days
  const timRevenueCollectedYearly = timRevenueCollectedMonthly * 12; // monthly * 12  



  // revenues collected calculations for AMA ----
  const amaRevenueCollectedMonthly = 15000;
  
  
  setDashboardData((prev)=>({
      ...prev,
      sheetData:{
        mtdInitialsHeld: { 
          total: (getAttorneyReportResp?.mtdrnInitialsHeld || 0)+(getAttorneyReportResp?.mtdadpInitialsHeld || 0)+(getAttorneyReportResp?.mtdtksInitialsHeld || 0)+(getAttorneyReportResp?.mtdOtherInitialsHeld || 0) , 
          rajiv: (getAttorneyReportResp?.mtdrnInitialsHeld || 0), 
          aaron: (getAttorneyReportResp?.mtdadpInitialsHeld || 0), 
          tim: (getAttorneyReportResp?.mtdtksInitialsHeld || 0), 
          ama: "", 
          seminar: "", 
          refunds: "", 
          other: (getAttorneyReportResp?.mtdOtherInitialsHeld || 0) 
        },
        mtdInitialsRetained: { 
          total: (getAttorneyReportResp?.mtdrnInitialsRetained || 0)+(getAttorneyReportResp?.mtdadpInitialsRetained || 0)+(getAttorneyReportResp?.mtdtksInitialsRetained || 0)+(getAttorneyReportResp?.mtdOtherInitialsRetained || 0) ,  
          rajiv:(getAttorneyReportResp?.mtdrnInitialsRetained || 0),
          aaron:(getAttorneyReportResp?.mtdadpInitialsRetained || 0),
          tim:(getAttorneyReportResp?.mtdtksInitialsRetained || 0),
          ama:"",
          seminar:"",
          refunds: "" ,
          other: (getAttorneyReportResp?.mtdOtherInitialsRetained || 0),
      },
      closedPercentage: { 
        total:  ((closedPercentagetotal==Infinity)?0:closedPercentagetotal || 0)+"%" , 
        rajiv:  ((closedPercentagerajiv==Infinity)?0:closedPercentagerajiv || 0)+"%", 
        aaron:  ((closedPercentageaaron==Infinity)?0:closedPercentageaaron || 0)+"%", 
        tim:  ((closedPercentagetim==Infinity)?0:closedPercentagetim || 0)+"%", 
        ama: "", 
        seminar: "", 
        refunds: "", 
        other: ((closedPercentageother==Infinity)?0:closedPercentageother || 0)+"%" 
      },
      mtdRevenueRetained: { 
        total: formatAmount((getAttorneyReportResp?.mtdrnRevenueRetained || 0)+(getAttorneyReportResp?.mtdadpRevenueRetained || 0)+(getAttorneyReportResp?.mtdtksRevenueRetained || 0)), 
        rajiv: formatAmount(getAttorneyReportResp?.mtdrnRevenueRetained || 0), 
        aaron: formatAmount(getAttorneyReportResp?.mtdadpRevenueRetained || 0), 
        tim: formatAmount(getAttorneyReportResp?.mtdtksRevenueRetained || 0), 
        ama: "", 
        seminar: "", 
        refunds: "", 
        other: formatAmount(Math.round(getAttorneyReportResp?.mtdotherRevenueRetained || 0) )
      },
      mtdRevenueCollected: {
        total: formatAmount((getAttorneyReportResp?.ytdrnRevenueRetained || 0)+(getAttorneyReportResp?.ytdadpRevenueRetained || 0)+(getAttorneyReportResp?.ytdtksRevenueRetained || 0)), 
        rajiv: formatAmount(getAttorneyReportResp?.ytdrnRevenueRetained || 0), 
        aaron: formatAmount(getAttorneyReportResp?.ytdadpRevenueRetained || 0), 
        tim: formatAmount(getAttorneyReportResp?.ytdtksRevenueRetained || 0), 
        ama: "", 
        seminar: "", 
        refunds: "", 
        other: formatAmount(Math.round(getAttorneyReportResp?.ytdotherRevenueRetained || 0))
      },
      mtdRevenueCollectedFromInitials: {
        total: formatAmount(((getAttorneyReportResp?.mtdrnRevenueCollectedFromInitials || 0)+(getAttorneyReportResp?.mtdadpRevenueCollectedFromInitials || 0)+(getAttorneyReportResp?.mtdtksRevenueCollectedFromInitials || 0)+(getAttorneyReportResp?.amamtdRevenueFromInitial || 0)+(getAttorneyReportResp?.sirmtdRevenueFromInitial || 0)+(getAttorneyReportResp?.mtdOtherRevenueCollectedFromInitials || 0)) || 0), 
        rajiv: formatAmount(getAttorneyReportResp?.mtdrnRevenueCollectedFromInitials || 0), 
        aaron: formatAmount(getAttorneyReportResp?.mtdadpRevenueCollectedFromInitials || 0), 
        tim: formatAmount(getAttorneyReportResp?.mtdtksRevenueCollectedFromInitials || 0), 
        ama: formatAmount(getAttorneyReportResp?.amamtdRevenueFromInitial || 0), 
        seminar: formatAmount(Math.round(getAttorneyReportResp?.sirmtdRevenueFromInitial || 0)), 
        refunds: "", 
        other: formatAmount(getAttorneyReportResp?.mtdOtherRevenueCollectedFromInitials || 0)
       },
       mtdRevenueCollectedNotFromInitials: {
        total: formatAmount(((getAttorneyReportResp?.mtdrnRevenueCollectedFromNotInitials || 0)+(getAttorneyReportResp?.mtdadpRevenueCollectedFromNotInitials || 0)+(getAttorneyReportResp?.mtdtksRevenueCollectedFromNotInitials || 0)+(getAttorneyReportResp?.amamtdRevenueNotFromInitial || 0)+(getAttorneyReportResp?.totalMonthlyRefund || 0)+(getAttorneyReportResp?.mtdOtherRevenueCollectedFromNotInitials || 0)) || 0), 
        rajiv: formatAmount(getAttorneyReportResp?.mtdrnRevenueCollectedFromNotInitials || 0), 
        aaron: formatAmount(getAttorneyReportResp?.mtdadpRevenueCollectedFromNotInitials || 0), 
        tim: formatAmount(getAttorneyReportResp?.mtdtksRevenueCollectedFromNotInitials || 0), 
        ama: formatAmount(getAttorneyReportResp?.amamtdRevenueNotFromInitial || 0), 
        seminar: "", 
        refunds: formatAmountWithBrackets((getAttorneyReportResp?.totalMonthlyRefund || 0)),
        other: formatAmount(getAttorneyReportResp?.mtdOtherRevenueCollectedFromNotInitials || 0),
        
      },
      mtdAvgColPerRetainedClient: {
        total: ((mtdTotalAvgColClient == Infinity || isNaN(mtdTotalAvgColClient)) ? 0 : (mtdTotalAvgColClient || 0)) + "%", 
        rajiv: ((mtdTotalRajeevAvgClient == Infinity || isNaN(mtdTotalRajeevAvgClient)) ? 0 : (mtdTotalRajeevAvgClient || 0)) + "%",  
        aaron: ((mtdTotalAaronAvgClient == Infinity || isNaN(mtdTotalAaronAvgClient)) ? 0 : (mtdTotalAaronAvgClient || 0)) + "%", 
        tim: ((mtdTotalTimAvgClient == Infinity || isNaN(mtdTotalTimAvgClient)) ? 0 : (mtdTotalTimAvgClient || 0)) + "%",
        ama: "", 
        seminar: "", 
        refunds: "", 
        other: ((mtdTotalOtherAvgClient == Infinity || isNaN(mtdTotalOtherAvgClient)) ? 0 : (mtdTotalOtherAvgClient || 0)) + "%",
      },
      mtdTotalCollected: {
        total: formatAmount((mtdTotalret==Infinity)?0:(mtdTotalret || 0)), 
        rajiv: formatAmount((mtdTotalretRajeev==Infinity)?0:(mtdTotalretRajeev || 0)), 
        aaron: formatAmount((mtdTotalretAaron==Infinity)?0:mtdTotalretAaron || 0), 
        tim: formatAmount((mtdTotalretTim==Infinity)?0:mtdTotalretTim || 0), 
        ama: formatAmount(mtdTotalretAma || 0), 
        seminar: formatAmount(Math.round(mtdTotalretSeminar || 0)), 
        refunds: formatAmountWithBrackets(mtdTotalretRefund || 0), 
        other: formatAmount((mtdTotalretOthers==Infinity)?0:mtdTotalretOthers || 0),
      },
      mtdGoal: {
        total: formatAmount(mtdGoalTotal), 
        rajiv: formatAmount(mtdGoalRajiv), 
        aaron: formatAmount(mtdGoalAaron), 
        tim: formatAmount(mtdGoalTim), 
        ama: formatAmount(mtdGoalAma), 
        seminar: formatAmount(mtdGoalSeminar), 
        refunds: "", 
        other: formatAmount(mtdGoalOther) 
      },

     mtdVariance: {
        total: formatAmountWithBrackets(mtdVarianceTotal), 
        rajiv: formatAmountWithBrackets(Math.floor(mtdVarianceRajiv)), 
        aaron: formatAmountWithBrackets(Math.floor(mtdVarianceAaron)), 
        tim: formatAmountWithBrackets(Math.floor(mtdVarianceTim)), 
        ama: "", 
        // ama: formatAmountWithBrackets(Math.floor(mtdVarianceAma)), 
        seminar: "", 
        // seminar: formatAmountWithBrackets(Math.floor(mtdVarianceSeminar)), 
        refunds: "", 
        other: formatAmountWithBrackets(Math.floor(mtdVarianceOther))
      },
      
     mtdVariancePercentage: {
        total: Math.round(mtdVariancePercentageTotal) + "%", 
        rajiv: Math.round(mtdVariancePercentageRajiv) + "%", 
        aaron: Math.round(mtdVariancePercentageAaron) + "%", 
        tim: Math.round(mtdVariancePercentageTim) + "%", 
        ama: "", 
        seminar: "", 
        // ama: Math.round(mtdVariancePercentageAma) + "%", 
        // seminar: Math.round(mtdVariancePercentageSeminar) + "%", 
        refunds: "", 
        other: Math.round(mtdVariancePercentageOther) + "%" 
      },

    

      },

      revenueCollected: {
        Rajiv: {
          daily: formatAmount(rajivRevenueCollectedDaily || 0),
          yesterday: formatAmount(getAttorneyReportResp?.totalYesterdayRN || 0),
          weekly: formatAmount(rajivRevenueCollectedWeekly || 0),
          wtd: formatAmount(getAttorneyReportResp?.totalWeeklyRN || 0),
          monthly: formatAmount(rajivRevenueCollectedMonthly || 0),
          mtd: formatAmount((getAttorneyReportResp?.mtdrnRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdrnRevenueCollectedFromNotInitials || 0)),
          yearly: formatAmount(rajivRevenueCollectedYearly || 0),
          ytd: formatAmount(getAttorneyReportResp?.totalYearRN || 0)
        },
        Aaron: {
          daily: formatAmount(aaronRevenueCollectedDaily || 0),
          yesterday: formatAmount(getAttorneyReportResp?.totalYesterdayADP || 0),
          weekly: formatAmount(aaronRevenueCollectedWeekly || 0),
          wtd: formatAmount(getAttorneyReportResp?.totalWeeklyADP || 0),
          monthly: formatAmount(aaronRevenueCollectedMonthly || 0),
          mtd: formatAmount((getAttorneyReportResp?.mtdadpRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdadpRevenueCollectedFromNotInitials || 0)),
          yearly: formatAmount(aaronRevenueCollectedYearly || 0),
          ytd: formatAmount(getAttorneyReportResp?.totalYearADP || 0) },
        Tim: {
          daily: formatAmount(timRevenueCollectedDaily || 0),
          yesterday: formatAmount(getAttorneyReportResp?.totalYesterdayTKS || 0),
          weekly: formatAmount(timRevenueCollectedWeekly || 0),
          wtd: formatAmount(getAttorneyReportResp?.totalWeeklyTKS || 0),
          monthly: formatAmount(timRevenueCollectedMonthly || 0),
          mtd: formatAmount((getAttorneyReportResp?.mtdtksRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdtksRevenueCollectedFromNotInitials || 0)),
          yearly: formatAmount(timRevenueCollectedYearly || 0),
          ytd: formatAmount(getAttorneyReportResp?.totalYearTKS || 0) },
        Ama: {
          daily: "",
          yesterday: formatAmount(getAttorneyReportResp?.totalYesterdayAMA || 0),
          weekly: "",
          wtd: formatAmount(getAttorneyReportResp?.totalWeeklyAMA || 0),
          monthly: formatAmount(amaRevenueCollectedMonthly || 0),
          mtd: formatAmount((getAttorneyReportResp?.amamtdRevenueFromInitial || 0) + (getAttorneyReportResp?.amamtdRevenueNotFromInitial || 0)),
          yearly: formatAmount(amaRevenueCollectedMonthly * 12 || 0),
          ytd: formatAmount(getAttorneyReportResp?.totalYearAMA || 0) },
        Seminar: {
          daily: "",
          yesterday: formatAmount(getAttorneyReportResp?.totalYesterdaySIR || 0),
          weekly: "",
          wtd: formatAmount(getAttorneyReportResp?.totalWeeklySIR || 0),
          monthly: formatAmount(10000),
          mtd: formatAmount(getAttorneyReportResp?.sirmtdRevenueFromInitial || 0),
          yearly: formatAmount(10000 * 12 || 0),
          ytd: formatAmount(getAttorneyReportResp?.totalYearSIR || 0) },
        Other: {
          daily: "",
          yesterday: formatAmount(getAttorneyReportResp?.totalYesterdayOther || 0),
          weekly: "",
          wtd: formatAmount(getAttorneyReportResp?.totalWeeklyOther || 0),
          monthly: "",
          mtd: formatAmount((getAttorneyReportResp?.mtdOtherRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdOtherRevenueCollectedFromNotInitials || 0)),
          yearly: "",
          ytd: formatAmount(getAttorneyReportResp?.totalYearOther || 0) },
        Refunds: {
          daily: "",
          yesterday: formatAmountWithBrackets(getAttorneyReportResp?.totalYesterdayRefund || 0),
          weekly: "",
          wtd: formatAmountWithBrackets(getAttorneyReportResp?.totalWeeklyRefund || 0),
          monthly: "",
          mtd: formatAmountWithBrackets(getAttorneyReportResp?.totalMonthlyRefund || 0),
          yearly: "",
          ytd: formatAmountWithBrackets(getAttorneyReportResp?.totalYearRefund || 0)
        },
        Total: {
          daily: "",
          yesterday: formatAmount(
            (getAttorneyReportResp?.totalYesterdayRN || 0) + 
            (getAttorneyReportResp?.totalYesterdayADP || 0) + 
            (getAttorneyReportResp?.totalYesterdayTKS || 0) + 
            (getAttorneyReportResp?.totalYesterdayAMA || 0) + 
            (getAttorneyReportResp?.totalYesterdaySIR || 0) + 
            (getAttorneyReportResp?.totalYesterdayOther || 0) +
            (getAttorneyReportResp?.totalYesterdayRefund || 0)
          ),
          weekly: "",
          wtd: formatAmount(
            (getAttorneyReportResp?.totalWeeklyRN || 0) + 
            (getAttorneyReportResp?.totalWeeklyADP || 0) + 
            (getAttorneyReportResp?.totalWeeklyTKS || 0) + 
            (getAttorneyReportResp?.totalWeeklyAMA || 0) + 
            (getAttorneyReportResp?.totalWeeklySIR || 0) + 
            (getAttorneyReportResp?.totalWeeklyOther || 0) +
            (getAttorneyReportResp?.totalWeeklyRefund || 0)
          ),
          monthly: "",
          mtd: formatAmount(
            ((getAttorneyReportResp?.mtdrnRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdrnRevenueCollectedFromNotInitials || 0)) + 
            ((getAttorneyReportResp?.mtdadpRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdadpRevenueCollectedFromNotInitials || 0)) + 
            ((getAttorneyReportResp?.mtdtksRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdtksRevenueCollectedFromNotInitials || 0)) + 
            ((getAttorneyReportResp?.amamtdRevenueFromInitial || 0) + (getAttorneyReportResp?.amamtdRevenueNotFromInitial || 0)) + 
            (getAttorneyReportResp?.sirmtdRevenueFromInitial || 0) + 
            ((getAttorneyReportResp?.mtdOtherRevenueCollectedFromInitials || 0) + (getAttorneyReportResp?.mtdOtherRevenueCollectedFromNotInitials || 0)) +
            (getAttorneyReportResp?.totalMonthlyRefund || 0)
          ),
          yearly: "",
          ytd: formatAmount(
            (getAttorneyReportResp?.totalYearRN || 0) + 
            (getAttorneyReportResp?.totalYearADP || 0) + 
            (getAttorneyReportResp?.totalYearTKS || 0) + 
            (getAttorneyReportResp?.totalYearAMA || 0) + 
            (getAttorneyReportResp?.totalYearSIR || 0) + 
            (getAttorneyReportResp?.totalYearOther || 0) +
            (getAttorneyReportResp?.totalYearRefund || 0)
          ) }
      }

      
      
  }))

}

async function fetchARDeptDataNewAPI(){
  // Format a date as YYYY-MM-DD
const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// 1️⃣ First date of the selected year
const yearFirstDate = formatDate(new Date(selectedYear, 0, 1));

// 2️⃣ Last date of the selected month
const currentMonthLastDate = formatDate(
  new Date(selectedYear, selectedMonth , 0)
);

const yesterDaysDate = getTargetDate(selectedMonth, selectedYear, 'YYYY-MM-DD');
  let getARDeptReportResp = await Services.getARDeptReportAsync(yearFirstDate,currentMonthLastDate,yesterDaysDate);
  getARDeptReportResp=getARDeptReportResp?.data // Remove [0] since data is not an array

  // Format amount with commas and brackets for negative values
  const formatAmountWithBrackets = (amount) => {
    if (amount <= 0) {
      return `$(${Math.abs(amount).toLocaleString()})`;
    }
    return `$${amount.toLocaleString()}`;
  };

  // Format amount with commas (for positive values)
  const formatAmount = (amount) => {
    return `$${amount.toLocaleString()}`;
  };

  // Calculate MTD variables for AR Department
  const mtdllpInitialsHeld = getARDeptReportResp?.mtdllpInitialsHeld || 0;
  const mtdcpInitialsHeld = getARDeptReportResp?.mtdcpInitialsHeld || 0;
  const mtdpInitialsHeld = getARDeptReportResp?.mtdpInitialsHeld || 0;
  const mtdsInitialsHeld = getARDeptReportResp?.mtdsInitialsHeld || 0;
  const mtdamaInitialsHeld = getARDeptReportResp?.mtdamaInitialsHeld || 0;
  const mtdOtherInitialsHeld = getARDeptReportResp?.mtdOtherInitialsHeld || 0;

  const mtdllpInitialsRetained = getARDeptReportResp?.mtdllpInitialsRetained || 0;
  const mtdcpInitialsRetained = getARDeptReportResp?.mtdcpInitialsRetained || 0;
  const mtdpInitialsRetained = getARDeptReportResp?.mtdpInitialsRetained || 0;
  const mtdsInitialsRetained = getARDeptReportResp?.mtdsInitialsRetained || 0;
  const mtdamaInitialsRetained = getARDeptReportResp?.mtdamaInitialsRetained || 0;
  const mtdOtherInitialsRetained = getARDeptReportResp?.mtdOtherInitialsRetained || 0;

  const mtdllpRevenueRetained = getARDeptReportResp?.mtdllpRevenueRetained || 0;
  const mtdcpRevenueRetained = getARDeptReportResp?.mtdcpRevenueRetained || 0;
  const mtdpRevenueRetained = getARDeptReportResp?.mtdpRevenueRetained || 0;
  const mtdsRevenueRetained = getARDeptReportResp?.mtdsRevenueRetained || 0;
  const mtdamaRevenueRetained = getARDeptReportResp?.mtdamaRevenueRetained || 0;
  const mtdotherRevenueRetained = getARDeptReportResp?.mtdotherRevenueRetained || 0;

  const mtdllpRevenueCollectedFromInitials = getARDeptReportResp?.mtdllpRevenueCollectedFromInitials || 0;
  const mtdcpRevenueCollectedFromInitials = getARDeptReportResp?.mtdcpRevenueCollectedFromInitials || 0;
  const mtdpRevenueCollectedFromInitials = getARDeptReportResp?.mtdpRevenueCollectedFromInitials || 0;
  const mtdsRevenueCollectedFromInitials = getARDeptReportResp?.mtdsRevenueCollectedFromInitials || 0;
  const mtdamaRevenueCollectedFromInitials = getARDeptReportResp?.mtdamaRevenueCollectedFromInitials || 0;
  const mtdOtherRevenueCollectedFromInitials = getARDeptReportResp?.mtdOtherRevenueCollectedFromInitials || 0;

  const mtdllpRevenueCollectedFromNotInitials = getARDeptReportResp?.mtdllpRevenueCollectedFromNotInitials || 0;
  const mtdcpRevenueCollectedFromNotInitials = getARDeptReportResp?.mtdcpRevenueCollectedFromNotInitials || 0;
  const mtdpRevenueCollectedFromNotInitials = getARDeptReportResp?.mtdpRevenueCollectedFromNotInitials || 0;
  const mtdsRevenueCollectedFromNotInitials = getARDeptReportResp?.mtdsRevenueCollectedFromNotInitials || 0;
  const mtdamaRevenueCollectedFromNotInitials = getARDeptReportResp?.mtdamaRevenueCollectedFromNotInitials || 0;
  const mtdOtherRevenueCollectedFromNotInitials = getARDeptReportResp?.mtdOtherRevenueCollectedFromNotInitials || 0;

  // Yesterday, Weekly, Monthly, Yearly totals for each department
  const totalYesterdayLLP = getARDeptReportResp?.totalYesterdayLLP || 0;
  const totalYesterdayCP = getARDeptReportResp?.totalYesterdayCP || 0;
  const totalYesterdayP = getARDeptReportResp?.totalYesterdayP || 0;
  const totalYesterdayS = getARDeptReportResp?.totalYesterdayS || 0;
  const totalYesterdayAMA = getARDeptReportResp?.totalYesterdayAMA || 0;
  const totalYesterdayOther = getARDeptReportResp?.totalYesterdayOther || 0;
  const totalYesterdayRefund = getARDeptReportResp?.totalYesterdayRefund || 0;

  const totalWeeklyLLP = getARDeptReportResp?.totalWeeklyLLP || 0;
  const totalWeeklyCP = getARDeptReportResp?.totalWeeklyCP || 0;
  const totalWeeklyP = getARDeptReportResp?.totalWeeklyP || 0;
  const totalWeeklyS = getARDeptReportResp?.totalWeeklyS || 0;
  const totalWeeklyAMA = getARDeptReportResp?.totalWeeklyAMA || 0;
  const totalWeeklyOther = getARDeptReportResp?.totalWeeklyOther || 0;
  const totalWeeklyRefund = getARDeptReportResp?.totalWeeklyRefund || 0;

  const totalMonthlyRefund = getARDeptReportResp?.totalMonthlyRefund || 0;

  const totalYearLLP = getARDeptReportResp?.totalYearLLP || 0;
  const totalYearCP = getARDeptReportResp?.totalYearCP || 0;
  const totalYearP = getARDeptReportResp?.totalYearP || 0;
  const totalYearS = getARDeptReportResp?.totalYearS || 0;
  const totalYearAMA = getARDeptReportResp?.totalYearAMA || 0;
  const totalYearOther = getARDeptReportResp?.totalYearOther || 0;
  const totalYearRefund = getARDeptReportResp?.totalYearRefund || 0;

  setArDeptDashboardData((prev)=>({
      ...prev,
      sheetData:{
        mtdInitialsHeld: { 
          // total: formatAmount(mtdllpInitialsHeld + mtdcpInitialsHeld + mtdpInitialsHeld + mtdsInitialsHeld + mtdamaInitialsHeld + mtdOtherInitialsHeld || 0),
          total: "",
          legalLifePlanning: mtdllpInitialsHeld || 0,
          crisis: mtdcpInitialsHeld || 0,
          probate: mtdpInitialsHeld || 0,
          seminar: mtdsInitialsHeld || 0,
          ama: mtdamaInitialsHeld || 0,
          other: mtdOtherInitialsHeld || 0,
          refund: ""
        },
        mtdRetained: { 
          // total: formatAmount( mtdllpInitialsRetained + mtdcpInitialsRetained + mtdpInitialsRetained + mtdsInitialsRetained + mtdamaInitialsRetained + mtdOtherInitialsRetained),
          total: "",
          legalLifePlanning: mtdllpInitialsRetained || 0,
          crisis: mtdcpInitialsRetained || 0,
          probate: mtdpInitialsRetained || 0,
          seminar: mtdsInitialsRetained || 0,
          ama: mtdamaInitialsRetained || 0,
          other: mtdOtherInitialsRetained || 0,
          refund: ""
        },
        closedPercentage: { 
          total: "0%",
          legalLifePlanning: "0%",
          crisis: "0%",
          probate: "0%",
          seminar: "0%",
          ama: "0%",
          other: "0%",
          refund: "0%"
        },
        mtdRevenueRetained: { 
          // total: formatAmount(mtdllpRevenueRetained + mtdcpRevenueRetained + mtdpRevenueRetained + mtdsRevenueRetained + mtdamaRevenueRetained + mtdotherRevenueRetained),
          total: "",
          legalLifePlanning: formatAmount(mtdllpRevenueRetained),
          crisis: formatAmount(mtdcpRevenueRetained),
          probate: formatAmount(mtdpRevenueRetained),
          seminar: formatAmount(mtdsRevenueRetained),
          ama: formatAmount(mtdamaRevenueRetained),
          other: formatAmount(mtdotherRevenueRetained),
          refund: ""
        },
        mtdRevenueCollectedFromInitials: {
          total: formatAmount(mtdllpRevenueCollectedFromInitials + mtdcpRevenueCollectedFromInitials + mtdpRevenueCollectedFromInitials + mtdsRevenueCollectedFromInitials + mtdamaRevenueCollectedFromInitials + mtdOtherRevenueCollectedFromInitials),
          legalLifePlanning: formatAmount(mtdllpRevenueCollectedFromInitials),
          crisis: formatAmount(mtdcpRevenueCollectedFromInitials),
          probate: formatAmount(mtdpRevenueCollectedFromInitials),
          seminar: formatAmount(mtdsRevenueCollectedFromInitials),
          ama: formatAmount(mtdamaRevenueCollectedFromInitials),
          other: formatAmount(mtdOtherRevenueCollectedFromInitials),
          refund: ""
        },
        mtdRevenueCollectedNotFromInitials: {
          total: formatAmount(mtdllpRevenueCollectedFromNotInitials + mtdcpRevenueCollectedFromNotInitials + mtdpRevenueCollectedFromNotInitials + mtdsRevenueCollectedFromNotInitials + mtdamaRevenueCollectedFromNotInitials + mtdOtherRevenueCollectedFromNotInitials + totalMonthlyRefund),
          legalLifePlanning: formatAmount(mtdllpRevenueCollectedFromNotInitials),
          crisis: formatAmount(mtdcpRevenueCollectedFromNotInitials),
          probate: formatAmount(mtdpRevenueCollectedFromNotInitials),
          seminar: formatAmount(mtdsRevenueCollectedFromNotInitials),
          ama: formatAmount(mtdamaRevenueCollectedFromNotInitials),
          other: formatAmount(mtdOtherRevenueCollectedFromNotInitials),
          refund: formatAmountWithBrackets(totalMonthlyRefund)
        },
        totalCollected: {
          total: formatAmount((mtdllpRevenueCollectedFromInitials + mtdllpRevenueCollectedFromNotInitials) + 
                            (mtdcpRevenueCollectedFromInitials + mtdcpRevenueCollectedFromNotInitials) + 
                            (mtdpRevenueCollectedFromInitials + mtdpRevenueCollectedFromNotInitials) + 
                            (mtdsRevenueCollectedFromInitials + mtdsRevenueCollectedFromNotInitials) + 
                            (mtdamaRevenueCollectedFromInitials + mtdamaRevenueCollectedFromNotInitials) + 
                            (mtdOtherRevenueCollectedFromInitials + mtdOtherRevenueCollectedFromNotInitials) + 
                            totalMonthlyRefund),
          legalLifePlanning: formatAmount(mtdllpRevenueCollectedFromInitials + mtdllpRevenueCollectedFromNotInitials),
          crisis: formatAmount(mtdcpRevenueCollectedFromInitials + mtdcpRevenueCollectedFromNotInitials),
          probate: formatAmount(mtdpRevenueCollectedFromInitials + mtdpRevenueCollectedFromNotInitials),
          seminar: formatAmount(mtdsRevenueCollectedFromInitials + mtdsRevenueCollectedFromNotInitials),
          ama: formatAmount(mtdamaRevenueCollectedFromInitials + mtdamaRevenueCollectedFromNotInitials),
          other: formatAmount(mtdOtherRevenueCollectedFromInitials + mtdOtherRevenueCollectedFromNotInitials),
          refund: formatAmountWithBrackets(totalMonthlyRefund)
        }
      },

      revenueCollected: {
        LegalLifePlanning: {
          daily: formatAmount(0),
          yesterday: formatAmount(totalYesterdayLLP),
          weekly: formatAmount(0),
          wtd: formatAmount(totalWeeklyLLP),
          monthly: formatAmount(0),
          mtd: formatAmount(mtdllpRevenueCollectedFromInitials + mtdllpRevenueCollectedFromNotInitials),
          yearly: formatAmount(0),
          ytd: formatAmount(totalYearLLP)
        },
        Crisis: {
          daily: formatAmount(0),
          yesterday: formatAmount(totalYesterdayCP || 0),
          weekly: formatAmount(0),
          wtd: formatAmount(totalWeeklyCP || 0),
          monthly: formatAmount(0),
          mtd: formatAmount(mtdcpRevenueCollectedFromInitials + mtdcpRevenueCollectedFromNotInitials || 0),
          yearly: formatAmount(0),
          ytd: formatAmount(totalYearCP || 0)
        },
        Probate: {
          daily: formatAmount(0),
          yesterday: formatAmount(totalYesterdayP || 0),
          weekly: formatAmount(0),
          wtd: formatAmount(totalWeeklyP || 0),
          monthly: formatAmount(0),
          mtd: formatAmount(mtdpRevenueCollectedFromInitials + mtdpRevenueCollectedFromNotInitials || 0),
          yearly: formatAmount(0),
          ytd: formatAmount(totalYearP || 0)
        },
        Seminar: {
          daily: "",
          yesterday: formatAmount(totalYesterdayS || 0),
          weekly: "",
          wtd: formatAmount(totalWeeklyS || 0),
          monthly: "",
          mtd: formatAmount(mtdsRevenueCollectedFromInitials + mtdsRevenueCollectedFromNotInitials || 0),
          yearly: "",
          ytd: formatAmount(totalYearS || 0)
        },
        Ama: {
          daily: "",
          yesterday: formatAmount(totalYesterdayAMA),
          weekly: "",
          wtd: formatAmount(totalWeeklyAMA),
          monthly: "",
          mtd: formatAmount(mtdamaRevenueCollectedFromInitials + mtdamaRevenueCollectedFromNotInitials),
          yearly: "",
          ytd: formatAmount(totalYearAMA)
        },
        Other: {
          daily: "",
          yesterday: formatAmount(totalYesterdayOther),
          weekly: "",
          wtd: formatAmount(totalWeeklyOther),
          monthly: "",
          mtd: formatAmount(mtdOtherRevenueCollectedFromInitials + mtdOtherRevenueCollectedFromNotInitials),
          yearly: "",
          ytd: formatAmount(totalYearOther)
        },
        Refunds: {
          daily: "",
          // daily: formatAmountWithBrackets(0),
          yesterday: formatAmountWithBrackets(totalYesterdayRefund),
          weekly: "",
          // weekly: formatAmountWithBrackets(0),
          wtd: formatAmountWithBrackets(totalWeeklyRefund),
          monthly: "",
          // monthly: formatAmountWithBrackets(0),
          mtd: formatAmountWithBrackets(totalMonthlyRefund),
          yearly: "",
          // yearly: formatAmountWithBrackets(0),
          ytd: formatAmountWithBrackets(totalYearRefund)
        },
        Total: {
          daily: "",
          yesterday: formatAmount(totalYesterdayLLP + totalYesterdayCP + totalYesterdayP + totalYesterdayS + totalYesterdayAMA + totalYesterdayOther + totalYesterdayRefund),
          weekly: "",
          wtd: formatAmount(totalWeeklyLLP + totalWeeklyCP + totalWeeklyP + totalWeeklyS + totalWeeklyAMA + totalWeeklyOther + totalWeeklyRefund),
          monthly: "",
          mtd: formatAmount((mtdllpRevenueCollectedFromInitials + mtdllpRevenueCollectedFromNotInitials) + 
                          (mtdcpRevenueCollectedFromInitials + mtdcpRevenueCollectedFromNotInitials) + 
                          (mtdpRevenueCollectedFromInitials + mtdpRevenueCollectedFromNotInitials) + 
                          (mtdsRevenueCollectedFromInitials + mtdsRevenueCollectedFromNotInitials) + 
                          (mtdamaRevenueCollectedFromInitials + mtdamaRevenueCollectedFromNotInitials) + 
                          (mtdOtherRevenueCollectedFromInitials + mtdOtherRevenueCollectedFromNotInitials) + 
                          totalMonthlyRefund),
          yearly: "",
          ytd: formatAmount(totalYearLLP + totalYearCP + totalYearP + totalYearS + totalYearAMA + totalYearOther + totalYearRefund)
        }
      }
  }))

}

async function fetchAttorneyData () {
  const yearstartDate = new Date(selectedYear, 0, 1);
  const todayDate = new Date();
  const monthStartDate = new Date(selectedYear, selectedMonth, 1);

  // Fetching Attorney's Revenue Data
  const payload = {
    "subtenantId": [
      subtenantId4AttorneyReport
    ],
    "startDate": yearstartDate,
    "endDate": todayDate,
    "monthDate": monthStartDate,
    "isMonthly": true,
    "isAttorneyData": true
  }
  setuseLoader(true)
  const attorneyRes = await Services.postApiCallNew('POST',AoUrl.getExceldataurl,payload);
  // let getAttorneyReportResp = await Services.getAttorneyReportAsync(yearstartDate,todayDate);
  // setuseLoader(false)
  // Joining attorney, AMA & Seminar
  let allData = [
    ...(attorneyRes?.resPonse?.data?.data?.[0]?.attorneyReports || []).map(ele => ({ nameOfHeader: ele?.responsibleAttorneyName, reportSheet: ele?.reportSheet })),
    ...(attorneyRes?.resPonse?.data?.data?.[0]?.eventAgreReportVMs || []).map(ele => ({ nameOfHeader: ele?.nameOfHeader, reportSheet: ele?.reportSheetVM }))
  ]

  // Formatting data as array of array
  let revenueReport = allData.map(eachEle => ([ 
    eachEle.nameOfHeader, 
    eachEle?.reportSheet?.totalYesterdayGoal || "",
    eachEle?.reportSheet?.totalYesterdayAmount || "",
    eachEle?.reportSheet?.totalWeeklyGoal || "",
    eachEle?.reportSheet?.totalWeeklyAmount || "",
    eachEle?.reportSheet?.totalMonthlyGoal || "",
    eachEle?.reportSheet?.totalMonthlyAmount || "",
    eachEle?.reportSheet?.totalYearlyGoal || "",
    eachEle?.reportSheet?.totalYearlyAmount || "",
  ]))

  let monthReport = allData.map(eachEle => ([ 
    eachEle.nameOfHeader, 
    "",
    "",
    "",
    "",
    eachEle?.reportSheet?.totalMonthAmount ?? "",
    "",
    eachEle?.reportSheet?.totalMonthAmount ?? "",
  ]))

  if(revenueReport?.length) {
    setRevenueData(revenueReport);
    setAttorneyMonthlyReport(monthReport)
  } else {
    setRevenueData([]);
    setAttorneyMonthlyReport([])
  }
}


// Example usage:
const input = { /* your JSON here */ };
const mergedSubtenant = mergeSubtenantMonths(input.data);
  const getStartAndEndDateOfYear = (year) => {
    const startDate = new Date(`${year-1}-01-01T00:00:00.000Z`);
    const endDate = new Date(`${year}-12-31T23:59:59.999Z`);
    return { startDate, endDate };
  };

  function getFirstAndLastDayOfMonthUTC(year, month) {
    const startDatem = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0));
    const endDatem = new Date(Date.UTC(year, month, 0, 23, 59, 59, 999));
    return { startDatem, endDatem };
  }

  const handleShowAttorneyReport = () => {
    setShowAttorneyReport(true); 
    setShowARDeptReport(false); // Hide AR Dept Report when showing Attorney Report
    setActiveButton('attorney');
  }

  const handleShowDashboard = () => {
    setShowAttorneyReport(false); 
    setShowARDeptReport(false); // Show ExcelTable by hiding both reports
    setActiveButton('dashboard');
  }

  const handleShowARDeptReport = () => {
    setShowARDeptReport(true);
    setShowAttorneyReport(false); // Hide Attorney Report when showing AR Dept Report
    setActiveButton('ardept');
    fetchARDeptDataNewAPI(); // Fetch AR Dept data when showing the report
  }

  const getExcelData = () => {
    getExcelDataApi(true)
    getExcelDataApi(false)
    fetchAttorneyData()
    fetchAttorneyDataNewAPi()
    fetchARDeptDataNewAPI() // Fetch AR Dept data with new month/year selection
    setSearchedYear(selectedYear);
    setSearchedMonth(selectedMonth);
  }

  const resetState = () => {
      let resetMonthObj = {months:[{days:[...adddummyDays()],month: months[selectedMonth-1]?.name,total:0}],year: selectedYear,yearTotal:0}
      setYearlyData([])
      setYearlyDatalpl([])
      setYearlyDataAo([])
      setYearlyDataFw([])
      setMonthlyData([])
      setMonthlydatalpl(resetMonthObj)
      setMonthlydataAo(resetMonthObj)
      setMonthlydataFw(resetMonthObj)
      setMonthlydataAll(resetMonthObj)
      setYearlyDatalplAll([])
  }

  const adddummyDays = () => {
  let resultArray = new Array(31).fill(null).map((_, index) => ({
      date: index + 1,total: '$0'}));
  return resultArray;
  }

  
  // Helper function to parse currency strings to numeric values
  function parseCurrencyToNumber(currencyStr) {
    if (!currencyStr || currencyStr === "" || typeof currencyStr !== 'string') {
      return null;
    }
    
    // Handle bracket-style negative values like $(48,894.25)
    const isNegative = currencyStr.includes('(') && currencyStr.includes(')');
    
    // Remove all non-numeric characters except decimal point and negative sign
    let numericStr = currencyStr.replace(/[$,()]/g, '');
    
    // Convert to number
    let value = parseFloat(numericStr);
    
    // Apply negative sign if it was in bracket format
    if (isNegative && value > 0) {
      value = -value;
    }
    
    return isNaN(value) ? null : value;
  }

  // Helper function to determine if a value should be treated as currency
  function isCurrencyField(rowLabel, value) {
    const currencyRows = [
      'MTD Initials Held',
      'MTD Initials Retained',
      'MTD Revenue Retained',
      'MTD Revenue Collected',
      'YTD Revenue Retained' ,
      'MTD Revenue Collected from initials',
      'MTD Revenue Collected not from initials',
      'MTD Goal',
      'MTD Variance'
    ];
    
    return currencyRows.includes(rowLabel) && 
           typeof value === 'string' && 
           (value.includes('$') || (value.includes('(') && value.includes(')')));
  }

  // Function to merge editable data with original data (user-specific)
  const mergeEditableData = (originalData, editableDataKey) => {
    // Get current user ID
    const getCurrentUserId = () => {
      return sessionStorage.getItem('loggedUserId') || sessionStorage.getItem('SessPrimaryUserId') || ''
    }
    
    const userId = getCurrentUserId()
    const savedEditableData = localStorage.getItem(`${editableDataKey}_${userId}`)
    if (!savedEditableData) return originalData

    const editableData = JSON.parse(savedEditableData)
    const mergedData = { ...originalData }

    // Merge editable data into sheetData
    if (mergedData.sheetData) {
      Object.keys(editableData).forEach(rowKey => {
        if (mergedData.sheetData[rowKey]) {
          mergedData.sheetData[rowKey] = { 
            ...mergedData.sheetData[rowKey], 
            ...editableData[rowKey] 
          }
        }
      })
    }

    return mergedData
  }

  // Helper function to parse numeric values from strings
  const parseNumericValue = (value) => {
    if (!value) return 0
    // Remove commas, dollar signs, parentheses, and other formatting
    const cleanValue = String(value).replace(/[$,()%]/g, '').trim()
    const num = parseFloat(cleanValue)
    return isNaN(num) ? 0 : num
  }

  // Helper function to format numbers back to display format
  const formatDisplayValue = (value, isPercentage = false) => {
    if (!value && value !== 0) return ''
    if (isPercentage) {
      return `${value}%`
    }
    return value.toLocaleString()
  }

  // Recalculate totals and percentages for merged data
  const recalculateData = (mergedData, reportType) => {
    if (!mergedData.sheetData) return mergedData

    const data = { ...mergedData }
    
    if (reportType === 'attorney') {
      const columns = ['rajiv', 'aaron', 'tim', 'ama', 'seminar', 'refunds', 'other']
      
      // Recalculate totals for editable rows
      const editableRows = [
        'mtdInitialsHeld',
        'mtdInitialsRetained', 
        'mtdRevenueRetained',
        'mtdRevenueCollected',
        'mtdRevenueCollectedFromInitials',
        'mtdRevenueCollectedNotFromInitials'
      ]

      editableRows.forEach(rowKey => {
        if (data.sheetData[rowKey]) {
          let total = 0
          columns.forEach(col => {
            const value = data.sheetData[rowKey][col] || 0
            total += parseNumericValue(value)
          })
          data.sheetData[rowKey].total = formatDisplayValue(total)
        }
      })

      // Recalculate closed percentage
      if (data.sheetData.closedPercentage) {
        columns.concat(['total']).forEach(col => {
          const retainedValue = data.sheetData.mtdInitialsRetained?.[col] || 0
          const heldValue = data.sheetData.mtdInitialsHeld?.[col] || 0
          
          const retained = parseNumericValue(retainedValue)
          const held = parseNumericValue(heldValue)
          
          if (held === 0) {
            data.sheetData.closedPercentage[col] = '0%'
          } else {
            const percentage = ((retained / held) * 100).toFixed(1)
            data.sheetData.closedPercentage[col] = `${percentage}%`
          }
        })
      }
    } else if (reportType === 'ardept') {
      const columns = ['legalLifePlanning', 'crisis', 'probate', 'seminar', 'ama', 'other', 'refund']
      
      // Recalculate totals for editable rows
      const editableRows = [
        'mtdInitialsHeld',
        'mtdRetained', 
        'mtdRevenueRetained',
        'mtdRevenueCollectedFromInitials',
        'mtdRevenueCollectedNotFromInitials'
      ]

      editableRows.forEach(rowKey => {
        if (data.sheetData[rowKey]) {
          let total = 0
          columns.forEach(col => {
            const value = data.sheetData[rowKey][col] || 0
            total += parseNumericValue(value)
          })
          data.sheetData[rowKey].total = formatDisplayValue(total)
        }
      })

      // Recalculate closed percentage
      if (data.sheetData.closedPercentage) {
        columns.concat(['total']).forEach(col => {
          const retainedValue = data.sheetData.mtdRetained?.[col] || 0
          const heldValue = data.sheetData.mtdInitialsHeld?.[col] || 0
          
          const retained = parseNumericValue(retainedValue)
          const held = parseNumericValue(heldValue)
          
          if (held === 0) {
            data.sheetData.closedPercentage[col] = '0%'
          } else {
            const percentage = ((retained / held) * 100).toFixed(1)
            data.sheetData.closedPercentage[col] = `${percentage}%`
          }
        })
      }
    }

    return data
  }

  function downloadDashboardExcel(dashboardData, selectedMonth, selectedYear) {
    const { sheetData, revenueCollected } = dashboardData;
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Attorney Report");
  
    const thinBorder = { style: "thin", color: { argb: "000000" } };
    const thickBorder = { style: "medium", color: { argb: "000000" } };
  
    // ==================== SUMMARY TABLE ====================
    // Add empty black row at B1:J1
    const emptyBlackRow = ws.addRow(["","","","","","","","","",""]);
    emptyBlackRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) return; // Skip column A
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "000000" } }; // Black background
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });

    // Add header row at B2:J2
    const monthsList = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const summaryHeader = ["", monthsList[Number(selectedMonth) - 1], "TOTAL", "RAJIV", "AARON", "TIM", "AMA", "Seminar/Initial/Radio Sponsorship", "Refunds", "Other"];
    ws.addRow(summaryHeader);
    
    // Format header row B2:J2
    ws.getRow(2).eachCell((cell, colNumber) => {
      if (colNumber === 1) return; // Skip column A
      cell.font = { bold: true, color: { argb: "000000" } }; // Black text
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } }; // White background
      cell.alignment = { horizontal: "center" };
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });
  
    const summaryRows = [
      ["MTD Initials Held", sheetData.mtdInitialsHeld],
      ["MTD Initials Retained", sheetData.mtdInitialsRetained],
      ["Closed percentage", sheetData.closedPercentage],
      ["MTD Revenue Retained", sheetData.mtdRevenueRetained],
      ["YTD Revenue Retained", sheetData.mtdRevenueCollected],
      ["MTD Revenue Collected from initials", sheetData.mtdRevenueCollectedFromInitials],
      ["MTD Revenue Collected not from initials", sheetData.mtdRevenueCollectedNotFromInitials],
      ["MTD Average Collection per Retained Client", sheetData.mtdAvgColPerRetainedClient],
      ["MTD TOTAL COLLECTED", sheetData.mtdTotalCollected],
      ["MTD Goal", sheetData.mtdGoal],
      ["MTD Variance", sheetData.mtdVariance],
      ["MTD Variance Percentage", sheetData.mtdVariancePercentage],
    ];
    
    summaryRows.forEach(row => {
      const rowData = [
        "", // Empty column A
        row[0],
        row[1]?.total ?? "",
        row[1]?.rajiv ?? "",
        row[1]?.aaron ?? "",
        row[1]?.tim ?? "",
        row[1]?.ama ?? "",
        row[1]?.seminar ?? "",
        row[1]?.refunds ?? "",
        row[1]?.other ?? ""
      ];

      const excelRow = ws.addRow(rowData);
    
      excelRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) return; // Skip column A
        
        // Handle currency formatting for data cells (columns 3-10)
        if (colNumber >= 3 && colNumber <= 10) {
          const cellValue = rowData[colNumber - 1]; // Adjust for 0-based array index
          
          if (isCurrencyField(row[0], cellValue)) {
            const numericValue = parseCurrencyToNumber(cellValue);
            if (numericValue !== null) {
              cell.value = numericValue;
              // Apply currency formatting - positive values as $#,##0.00, negative as $(#,##0.00)
              cell.numFmt = '_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)';
            }
          }
        }
        
        cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    
        const columnColors = {
          4: "FFF6A5A5", // rajiv (shifted from 3 to 4)
          5: "FFFFD966", // aaron (shifted from 4 to 5)
          6: "FF93C47D", // tim (shifted from 5 to 6)
          7: "FFE691E6", // ama (shifted from 6 to 7)
          8: "FF00B0F0", // seminar (shifted from 7 to 8)
          9: "FF00FFFF", // refunds (shifted from 8 to 9)
          10: "FFB6D7A8"  // other (shifted from 9 to 10)
        };
    
        if (columnColors[colNumber]) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: columnColors[colNumber] }
          };
        }
      });
    
      // 👇 Add black separator row after specific row
      if (row[0] == "MTD Average Collection per Retained Client") {
        const blackRow = ws.addRow(["","","","","","","","","",""]);
    
        blackRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) return; // Skip column A
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "000000" }, // black background
          };
          cell.font = { color: { argb: "FFFFFF" }, bold: true }; // white text
          cell.alignment = { horizontal: "center" };
        });
      }
    });

    // Add black separator row at B15:J15 (after all summary data)
    const blackSeparatorRow = ws.addRow(["","","","","","","","","",""]);
    blackSeparatorRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) return; // Skip column A
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "000000" }, // black background
      };
      cell.font = { color: { argb: "FFFFFF" }, bold: true }; // white text
      cell.alignment = { horizontal: "center" };
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });

    const summaryStart = 1; // Start from row 1 (empty black row)
    const summaryEnd = ws.lastRow.number;
  
    for (let R = summaryStart; R <= summaryEnd; R++) {
      for (let C = 2; C <= 10; C++) { // Changed from C = 1 to C = 2, and 9 to 10
        const cell = ws.getRow(R).getCell(C);
        const existingBorder = cell.border || {};
        cell.border = {
          top: R === summaryStart ? thickBorder : (existingBorder.top ?? thinBorder),
          bottom: R === summaryEnd ? thickBorder : (existingBorder.bottom ?? thinBorder),
          left: C === 2 ? thickBorder : (existingBorder.left ?? thinBorder), // Changed from C === 1 to C === 2
          right: C === 10 ? thickBorder : (existingBorder.right ?? thinBorder), // Changed from C === 9 to C === 10
        };
      }
    }
  
    // ==================== REVENUE TABLE ====================
    // Revenue data starts at B16
    const revenueHeaderRow = ws.addRow(["", "REVENUES COLLECTED", "DAY", "DAY", "WEEK", "WEEK", "MONTH", "MONTH", "YTD", "YTD"]);

    // Get the row number dynamically
    const rowNumber = revenueHeaderRow.number;

    // Merge repeated cells (shifted by one column)
    ws.mergeCells(`C${rowNumber}:D${rowNumber}`); // Day (was B:C)
    ws.mergeCells(`E${rowNumber}:F${rowNumber}`); // Week (was D:E)
    ws.mergeCells(`G${rowNumber}:H${rowNumber}`); // Month (was F:G)
    ws.mergeCells(`I${rowNumber}:J${rowNumber}`); // YTD (was H:I)

    // Center the merged text (shifted by one column)
    ['C','E','G','I'].forEach(col => {
        ws.getCell(`${col}${rowNumber}`).alignment = { horizontal: 'center', vertical: 'middle' };
    });

    
  const _targetDateStr = getTargetDate(selectedMonth, selectedYear, 'MM/DD/YYYY');
    const row2 = ws.addRow(["", _targetDateStr,"Daily Goal", "Yesterday Actual", "Weekly Goal", "Wtd Actual", "Monthly Goal", "Mtd Actual", "Yearly Goal", "Ytd Actual"]);
    row2.eachCell((cell, colNumber) => {
      if (colNumber === 1) return; // Skip column A
      cell.alignment = { horizontal: "center" };
    });
    ws.getRow(ws.lastRow.number - 1).eachCell(cell => (cell.font = { bold: true }));
    ws.getRow(ws.lastRow.number).eachCell(cell => (cell.font = { bold: true }));
  
    const rowColors = ["F6A5A5","FFD966","93C47D","E691E6","00B0F0","B6D7A8","00FFFF","FFFFFF"];
    const revenueKeys = Object.keys(revenueCollected);
    const revenueStartRow = ws.lastRow.number + 1;
  
    revenueKeys.forEach((key, index) => {
      const val = revenueCollected[key];
      const rowData = [
        "", // Empty column A
        key,
        val?.daily ?? "",
        val?.yesterday ?? "",
        val?.weekly ?? "",
        val?.wtd ?? "",
        val?.monthly ?? "",
        val?.mtd ?? "",
        val?.yearly ?? "",
        val?.ytd ?? ""
      ];

      const row = ws.addRow(rowData);
  
      const bgColor = rowColors[index % rowColors.length];
      row.eachCell((cell, colNumber) => {
        if (colNumber === 1) return; // Skip column A
        
        // Handle currency formatting for revenue data (columns 3-10)
        if (colNumber >= 3 && colNumber <= 10) {
          const cellValue = rowData[colNumber - 1]; // Adjust for 0-based array index
          
          // Check if the value looks like currency (contains $ or is a formatted number)
          if (typeof cellValue === 'string' && (cellValue.includes('$') || cellValue.includes(','))) {
            const numericValue = parseCurrencyToNumber(cellValue);
            if (numericValue !== null) {
              cell.value = numericValue;
              // Apply currency formatting - positive values as $#,##0.00, negative as $(#,##0.00)
              cell.numFmt = '_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)';
            }
          }
        }
        
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
        cell.alignment = { horizontal: "center" };
        cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
      });
  
      row.getCell(2).font = { bold: true }; // Changed from getCell(1) to getCell(2)
      row.getCell(2).alignment = { horizontal: "left" };
    });
  
    const revenueEndRow = ws.lastRow.number;
  
    for (let R = revenueStartRow - 2; R <= revenueEndRow; R++) {
      for (let C = 2; C <= 10; C++) { // Changed from C = 1 to C = 2, and 9 to 10
        const cell = ws.getRow(R).getCell(C);
        const existingBorder = cell.border || {};
        cell.border = {
          top: R === revenueStartRow - 2 ? thickBorder : (existingBorder.top ?? thinBorder),
          bottom: R === revenueEndRow ? thickBorder : (existingBorder.bottom ?? thinBorder),
          left: C === 2 ? thickBorder : (existingBorder.left ?? thinBorder), // Changed from C === 1 to C === 2
          right: C === 10 ? thickBorder : (existingBorder.right ?? thinBorder), // Changed from C === 9 to C === 10
        };
      }
    }
  
    // Auto-size columns
    ws.columns.forEach(col => (col.width = 15));
  
    wb.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), "AttorneyReport.xlsx");
    });
  }

  function downloadARDeptExcel(arDeptDashboardData, selectedMonth, selectedYear) {
    const { sheetData, revenueCollected } = arDeptDashboardData;
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("AR Department Report");
  
    const thinBorder = { style: "thin", color: { argb: "000000" } };
    const thickBorder = { style: "medium", color: { argb: "000000" } };

    // Helper function to parse currency strings to numeric values
    function parseCurrencyToNumber(currencyStr) {
      if (!currencyStr || currencyStr === "" || typeof currencyStr !== 'string') {
        return null;
      }
      
      // Handle bracket-style negative values like $(48,894.25)
      const isNegative = currencyStr.includes('(') && currencyStr.includes(')');
      
      // Remove all non-numeric characters except decimal point and negative sign
      let numericStr = currencyStr.replace(/[$,()]/g, '');
      
      // Convert to number
      const numericValue = parseFloat(numericStr);
      
      // Apply negative sign if needed
      return isNegative ? -numericValue : numericValue;
    }

    // Helper function to determine if a value should be treated as currency
    function isCurrencyField(rowLabel, value) {
      const currencyRows = [
        'MTD Initials/Demos Held',
        'MTD Retained',
        'MTD Revenue Retained',
        'MTD Revenue Collected From Initials',
        'MTD Revenue Collected not from initials',
        'TOTAL COLLECTED'
      ];
      
      return currencyRows.includes(rowLabel) && 
             typeof value === 'string' && 
             (value.includes('$') || value.includes(',') || (value.includes('(') && value.includes(')')));
    }
  
    // ==================== AR DEPARTMENT SUMMARY TABLE ====================
    // Add empty black row at A1:J1 (don't skip column A)
    const emptyBlackRow = ws.addRow(["","","","","","","","","",""]);
    emptyBlackRow.eachCell((cell, colNumber) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "000000" } }; // Black background
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });

    // Add header row at A2:J2 (don't skip column A)
    const monthsList = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const summaryHeader = [monthsList[Number(selectedMonth) - 1], "LEGAL-LIFEPLANNING", "CRISIS", "PROBATE", "Seminar/Initial", "AMA", "Other(Immigration, Litigation, Radio Sponsorship)", "Refund", "TOTAL"];
    ws.addRow(summaryHeader);
    
    // Format header row A2:J2 with AR Department colors (don't skip column A)
    ws.getRow(2).eachCell((cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "000000" } }; // Black text
      cell.alignment = { horizontal: "center" };
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
      
      // Apply AR Department colors (starting from column 1, not skipping column A)
      switch(colNumber) {
        case 1: // Month
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } }; // White
          break;
        case 2: // LEGAL-LIFEPLANNING
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6A5A5" } }; // Light red
          break;
        case 3: // CRISIS
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD966" } }; // Yellow/orange
          break;
        case 4: // PROBATE
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00B0F0" } }; // Blue
          break;
        case 5: // Seminar
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "8AE777" } }; // Green
          break;
        case 6: // AMA
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E691E6" } }; // Purple
          break;
        case 7: // Other
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } }; // Grey
          break;
        case 8: // Refund
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00FFFF" } }; // Light blue
          break;
        case 9: // Total
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } }; // White
          break;
      }
    });
  
    const summaryRows = [
      ["MTD Initials/Demos Held", sheetData.mtdInitialsHeld],
      ["MTD Retained", sheetData.mtdRetained],
      ["Closed Percentage", sheetData.closedPercentage],
      ["MTD Revenue Retained", sheetData.mtdRevenueRetained],
      ["MTD Revenue Collected From Initials", sheetData.mtdRevenueCollectedFromInitials],
      ["MTD Revenue Collected not from initials", sheetData.mtdRevenueCollectedNotFromInitials],
      ["TOTAL COLLECTED", sheetData.totalCollected]
    ];
  
    summaryRows.forEach((rowData, index) => {
      const [label, data] = rowData;
      const row = ws.addRow([
        label,
        data.legalLifePlanning,
        data.crisis,
        data.probate,
        data.seminar,
        data.ama,
        data.other,
        data.refund,
        data.total
      ]);
      
      // Format data cells with same colors as headers
      row.eachCell((cell, colNumber) => {
        cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
        
        // Handle currency formatting for data cells (columns 2-9)
        if (colNumber >= 2 && colNumber <= 9) {
          const cellValue = row.getCell(colNumber).value;
          
          if (isCurrencyField(label, cellValue)) {
            const numericValue = parseCurrencyToNumber(cellValue);
            
            if (numericValue !== null) {
              cell.value = numericValue;
              // Apply currency formatting - positive values as $#,##0.00, negative as $(#,##0.00)
              cell.numFmt = '_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)';
            }
          }
        }
        
        if (colNumber === 1) { // Label column
          cell.font = { bold: true };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
          cell.alignment = { horizontal: "left" };
        } else {
          // Apply same colors as headers
          switch(colNumber) {
            case 2: // LEGAL-LIFEPLANNING
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6A5A5" } };
              break;
            case 3: // CRISIS
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD966" } };
              break;
            case 4: // PROBATE
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00B0F0" } };
              break;
            case 5: // Seminar
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "8AE777" } };
              break;
            case 6: // AMA
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E691E6" } };
              break;
            case 7: // Other
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } };
              break;
            case 8: // Refund
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00FFFF" } };
              break;
            case 9: // Total
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
              if (label === "TOTAL COLLECTED") {
                cell.font = { bold: true, color: { argb: "008000" } }; // Green text
              }
              break;
          }
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Add black row before Revenue Collected section
    const blackRow = ws.addRow(["","","","","","","","","",""]);
    blackRow.eachCell((cell, colNumber) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "000000" } }; // Black background
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });
  
    // ==================== REVENUE COLLECTED TABLE ====================
    const revenueStartRow = ws.rowCount + 1;
    
    // Revenue table headers (don't skip column A)
    const revenueHeader1 = ["REVENUE COLLECTED", "", "DAY", "", "WEEK", "", "MONTH", "", "YTD"];
    
  const _targetDateStr = getTargetDate(selectedMonth, selectedYear, 'MM/DD/YYYY');
    const revenueHeader2 = [_targetDateStr, "Daily Goal", "Yesterday Actual", "Weekly Goal", "Wtd Actual", "Monthly Goal", "Mtd Actual", "Yearly Goal", "Ytd Actual"];
    
    ws.addRow(revenueHeader1);
    ws.addRow(revenueHeader2);
    
    // Format revenue headers (don't skip column A)
    const headerRow1 = ws.getRow(revenueStartRow);
    const headerRow2 = ws.getRow(revenueStartRow + 1);
    
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
      cell.alignment = { horizontal: "center" };
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });
    
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
      cell.alignment = { horizontal: "center" };
      cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
    });
    
    // Revenue data rows (don't skip column A)
    Object.entries(revenueCollected).forEach(([key, val]) => {
      const displayName = key === 'LegalLifePlanning' ? 'LEGAL-LIFEPLANNING' : 
                         key === 'Crisis' ? 'CRISIS' :
                         key === 'Probate' ? 'PROBATE' :
                         key === 'Seminar' ? 'SEMINAR' :
                         key === 'Ama' ? 'AMA' :
                         key === 'Other' ? 'OTHER' :
                         key === 'Refunds' ? 'Refund' :
                         key === 'Total' ? 'TOTAL' : key.toUpperCase();
      const row = ws.addRow([
        displayName,
        val.daily,
        val.yesterday,
        val.weekly,
        val.wtd,
        val.monthly,
        val.mtd,
        val.yearly,
        val.ytd
      ]);
      
      // Apply colors to revenue rows
      row.eachCell((cell, colNumber) => {
        cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
        
        // Handle currency formatting for revenue data cells (columns 2-9)
        if (colNumber >= 2 && colNumber <= 9) {
          const cellValue = row.getCell(colNumber).value;
          
          if (typeof cellValue === 'string' && (cellValue.includes('$') || cellValue.includes(',') || (cellValue.includes('(') && cellValue.includes(')')))) {
            const numericValue = parseCurrencyToNumber(cellValue);
            
            if (numericValue !== null) {
              cell.value = numericValue;
              // Apply currency formatting - positive values as $#,##0.00, negative as $(#,##0.00)
              cell.numFmt = '_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)';
            }
          }
        }
        
        if (colNumber === 1) { // Department name column
          cell.font = { bold: true };
          cell.alignment = { horizontal: "left" };
          
          // Apply department colors
          switch(key) {
            case 'LegalLifePlanning':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6A5A5" } };
              break;
            case 'Crisis':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD966" } };
              break;
            case 'Probate':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00B0F0" } };
              break;
            case 'Seminar':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "8AE777" } };
              break;
            case 'Ama':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E691E6" } };
              break;
            case 'Other':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } };
              break;
            case 'Refunds':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00FFFF" } };
              break;
            case 'Total':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
              cell.font = { bold: true, color: { argb: "008000" } }; // Green text
              break;
          }
        } else {
          // Apply same color to all cells in the row
          switch(key) {
            case 'LegalLifePlanning':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6A5A5" } };
              break;
            case 'Crisis':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD966" } };
              break;
            case 'Probate':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00B0F0" } };
              break;
            case 'Seminar':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "8AE777" } };
              break;
            case 'Ama':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E691E6" } };
              break;
            case 'Other':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } };
              break;
            case 'Refunds':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00FFFF" } };
              break;
            case 'Total':
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
              cell.font = { bold: true, color: { argb: "008000" } }; // Green text
              break;
          }
          cell.alignment = { horizontal: "center" };
        }
      });
    });
    
    // Set column widths
    ws.columns.forEach(col => (col.width = 15));
  
    wb.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DepartmentReport.xlsx");
    });
  }

  return (
    <>
    <div className="ExcelSheet">
        <div className="w-100 flex gap-3 my-3 mx-5 mt-5">
          <button className="w-1/8 bg-gray-200 text-white font-semibold py-2 px-4 rounded" onClick={()=>setShowExcle(false)}><img className="w-[10px]" src="/back.svg" alt="Back" /></button>
          {/* {showAttorneyReport == false && <> */}
          <label className="font-bold pt-2">Select Month:</label>
          <select className="w-1/6 px-2 py-2 border border-gray-300 rounded-md" placeholder="Select Month" onChange={(e)=>setSelectedMonth(e.target.value)} value={selectedMonth}>
            {months.map((e) => (<option key={e.id} value={e.id}>{e.name}</option>))}
          </select>
          <label className="font-bold self-center ml-2">Select Year:</label>
          <select className="w-1/5 px-3 py-2 border border-gray-300 rounded-md" placeholder="Select Year" onChange={(e)=>setSelectedYear(e.target.value)} value={selectedYear}>
            {getLast10Years().map((e) => <option key={e.id} value={e.id}>{e.label}</option>)}
          </select>
          <button 
            className={`w-1/8 font-semibold py-2 px-4 rounded transition-all duration-200 ${
              applyClicked 
                ? 'bg-emerald-500 text-white shadow-lg transform scale-95' 
                : 'bg-gradient-to-r from-emerald-400 to-teal-400 text-white hover:from-emerald-500 hover:to-teal-500 shadow-md hover:shadow-lg'
            }`}
            onClick={() => {
              setApplyClicked(true);
              getExcelData();
              setTimeout(() => setApplyClicked(false), 200);
            }}
          >
            Apply
          </button>
          {/* </>} */}
          
          {/* {(demo == true && subtenantIdExcel != 'federal_way_plaza') &&  */}
          
          <button 
            className={`w-1/8 mx-2 font-semibold py-2 px-4 rounded transition-all duration-200 ${
              activeButton === 'dashboard' 
                ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg' 
                : 'bg-gradient-to-r from-slate-100 to-slate-200 text-slate-700 hover:from-indigo-100 hover:to-purple-100 hover:text-indigo-700 shadow-md hover:shadow-lg'
            }`}
            onClick={handleShowDashboard}
          > 
            Deposit Report
          </button>
          <button 
            className={`w-1/8 mx-2 font-semibold py-2 px-4 rounded transition-all duration-200 ${
              activeButton === 'attorney' 
                ? 'bg-gradient-to-r from-rose-500 to-pink-600 text-white shadow-lg' 
                : 'bg-gradient-to-r from-slate-100 to-slate-200 text-slate-700 hover:from-rose-100 hover:to-pink-100 hover:text-rose-700 shadow-md hover:shadow-lg'
            }`}
            onClick={handleShowAttorneyReport}
          >
            Attorney Report
          </button>
          <button 
            className={`w-1/8 mx-2 font-semibold py-2 px-4 rounded transition-all duration-200 ${
              activeButton === 'ardept' 
                ? 'bg-gradient-to-r from-amber-500 to-orange-600 text-white shadow-lg' 
                : 'bg-gradient-to-r from-slate-100 to-slate-200 text-slate-700 hover:from-amber-100 hover:to-orange-100 hover:text-amber-700 shadow-md hover:shadow-lg'
            }`}
            onClick={handleShowARDeptReport}
          >
            Dept. Report
          </button>
          {/* } */}
          {!showAttorneyReport && !showARDeptReport? <ExcelExtracter selectedMonth={searchedMonth} selectedYear={searchedYear} yearlydata={{
              "LPL": yearlyDatalpl?.years,
              "AO": yearlyDataAo?.years,
              "NH": yearlyDataNd?.years,
              "FWPP": yearlyDataFw?.years,
              "TOTAL": yearlyDataAll?.years,
            }} monthlydata={{
              "LPL": monthlyDatalpl?.months?.[0],
              "AO": monthlyDataAo?.months?.[0],
              // "NH": monthlyDatalpl?.months?.[0],
              "FWPP": monthlyDataFw?.months?.[0],
              "TOTAL": monthlyDataAll?.months?.[0],
            }}
            monthlyEditdata={{
              "LPL": monthlyDatalpl,
              "AO": monthlyDataAo,
              // "NH": monthlyDatalpl?.months?.[0],
              "FWPP": monthlyDataFw,
              "TOTAL": monthlyDataAll,
            }} 
            bottomBlockdata={{
              "LPL":lplexcelCard,
              "AO":aoexcelCard,
              "FW":fwexcelCard,
              "TOTAL":allexcelCard
            }}
            revenueData={revenueData}
            attorneyMonthlyReport={attorneyMonthlyReport}
            showAttorneyReport={showAttorneyReport}
            showDataExcel={subtenantIdExcel == 'life_point_law' ? 'LPL' : subtenantIdExcel == 'aging_options' ? 'AO' : subtenantIdExcel == 'federal_way_plaza' ? 'FWPP' : 'ALL'}
            subtenantIdExcel={subtenantIdExcel}
          /> :
          <button 
            className={`w-1/8 font-semibold py-2 px-4 rounded transition-all duration-200 ${
              downloadClicked 
                ? 'bg-green-600 text-white shadow-lg transform scale-95' 
                : 'bg-gradient-to-r from-green-400 to-emerald-500 text-white hover:from-green-500 hover:to-emerald-600 shadow-md hover:shadow-lg'
            }`}
            onClick={() => {
              setDownloadClicked(true);
              if (showAttorneyReport) {
                // Merge editable data and recalculate before downloading
                const mergedDashboardData = mergeEditableData(dashboardData, 'attorneyReportEditableData')
                const recalculatedData = recalculateData(mergedDashboardData, 'attorney')
                downloadDashboardExcel(recalculatedData, searchedMonth, searchedYear);
              } else if (showARDeptReport) {
                // Merge editable data and recalculate before downloading
                const mergedArDeptData = mergeEditableData(arDeptDashboardData, 'arDeptReportEditableData')
                const recalculatedData = recalculateData(mergedArDeptData, 'ardept')
                downloadARDeptExcel(recalculatedData, searchedMonth, searchedYear);
              }
              setTimeout(() => setDownloadClicked(false), 200);
            }}
          >
            Download 
          </button>
          }
        </div>

        
        {showAttorneyReport == false && showARDeptReport == false && <div className="w-100 flex overflow-x-auto my-5 mx-4">
        {(subtenantIdExcel == 'life_point_law' || subtenantIdExcel == 'All_Companies') && <ExcelTable name="LIFE POINT LAW" color='red-500' selectedMonth={searchedMonth} year={searchedYear} yearlydata={yearlyDatalpl?.years} monthlydata={monthlyDatalpl} setMonthlydata={setMonthlydatalpl} shortName="LPL" />}
        {(subtenantIdExcel == 'aging_options' || subtenantIdExcel == 'All_Companies') && <ExcelTable name="AGING OPTIONS, INC" color='green-500' selectedMonth={searchedMonth} year={searchedYear} yearlydata={yearlyDataAo?.years} monthlydata={monthlyDataAo} setMonthlydata={setMonthlydataAo} shortName="AO"  />}
        {(subtenantIdExcel == 'federal_way_plaza' || subtenantIdExcel == 'All_Companies') && <ExcelTable name="FEDERAL WAY PROF. PLAZA" color="blue-500" selectedMonth={searchedMonth} year={searchedYear} yearlydata={yearlyDataFw?.years} monthlydata={monthlyDataFw} setMonthlydata={setMonthlydataFw} shortName="FWPP"  />}
        {(subtenantIdExcel == 'All_Companies'|| subtenantIdExcel == 'All_Companies' ) && <ExcelTable name="ALL COMPANIES COMBINED" color="gray-200" selectedMonth={searchedMonth} year={searchedYear} yearlydata={yearlyDataAll?.years} monthlydata={monthlyDataAll} setMonthlydata={setMonthlydataAll} shortName="TOTAL" />}
        </div>}
        {/* {showAttorneyReport == false && <div className="">
          {(subtenantIdExcel == 'All_Companies') && <EntitiesTable name="All Entities" excelCard={{ ...allexcelCard, redsofar: ((lplexcelCard?.redsofar || 0)+ (aoexcelCard?.redsofar || 0) + (fwexcelCard?.redsofar || 0))}} setExcelcard={setAllexcelcard} selectedYear={selectedYear} selectedMonth={selectedMonth} monthlydata={monthlyDataAll} subtenantId={[lplSubtenantId]} setuseLoader={setuseLoader} />}
          {(subtenantIdExcel == 'life_point_law' || subtenantIdExcel == 'All_Companies') && <EntitiesTable name="LPL" selectedYear={selectedYear} excelCard={lplexcelCard} setExcelcard={setLplexcelcard} selectedMonth={selectedMonth} monthlydata={monthlyDatalpl} subtenantId={[lplSubtenantId]} setuseLoader={setuseLoader} />}
          {(subtenantIdExcel == 'aging_options' || subtenantIdExcel == 'All_Companies') && <EntitiesTable name="AO" excelCard={aoexcelCard} setExcelcard={setAoexcelcard} selectedYear={selectedYear} selectedMonth={selectedMonth} monthlydata={monthlyDataAo} subtenantId={[3]} setuseLoader={setuseLoader}  />}
          {(subtenantIdExcel == 'federal_way_plaza' || subtenantIdExcel == 'All_Companies') && <EntitiesTable name="FWPP" excelCard={fwexcelCard} setExcelcard={setFwexcelcard} selectedYear={selectedYear} selectedMonth={selectedMonth} monthlydata={monthlyDataFw} subtenantId={[federal_way_plazaId]} setuseLoader={setuseLoader} />}
        </div>} */}
        <div>
          {showAttorneyReport && 
          <AttorneyReport dashboardData={dashboardData} revenueData={revenueData} attorneyMonthlyReport={attorneyMonthlyReport} selectedMonth={searchedMonth} selectedYear={searchedYear} />}
          {showARDeptReport && 
          <ARDeptReport 
            selectedMonth={searchedMonth} 
            selectedYear={searchedYear} 
            dashboardData={arDeptDashboardData}
          />}
        </div>
    </div>
  </>
  );
};

export default ExcleDashbord;
